/* eslint-disable max-len */
import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const ChevronDownIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <path d="M20.4949 7.49653C20.175 7.17851 19.7422 7 19.2911 7C18.84 7 18.4072 7.17851 18.0873 7.49653L11.9573 13.5412L5.91269 7.49653C5.59276 7.17851 5.15999 7 4.70888 7C4.25778 7 3.82501 7.17851 3.50508 7.49653C3.34504 7.65527 3.21801 7.84412 3.13132 8.0522C3.04463 8.26028 3 8.48346 3 8.70887C3 8.93429 3.04463 9.15747 3.13132 9.36555C3.21801 9.57362 3.34504 9.76248 3.50508 9.92121L10.745 17.1611C10.9037 17.3211 11.0926 17.4482 11.3006 17.5349C11.5087 17.6216 11.7319 17.6662 11.9573 17.6662C12.1827 17.6662 12.4059 17.6216 12.614 17.5349C12.8221 17.4482 13.0109 17.3211 13.1697 17.1611L20.4949 9.92121C20.655 9.76248 20.782 9.57362 20.8687 9.36555C20.9554 9.15747 21 8.93429 21 8.70887C21 8.48346 20.9554 8.26028 20.8687 8.0522C20.782 7.84412 20.655 7.65527 20.4949 7.49653Z" fill="currentColor" />
        </SvgIcon>
    );
};

export default ChevronDownIcon;
